(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ohana-premium-home"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-ohana-sample-selector]').forEach((selector) => {
    const output = selector.querySelector('[data-sample-output]');
    const price = selector.querySelector('[data-sample-price]');
    const view = selector.querySelector('[data-sample-view]');
    const add = selector.querySelector('[data-sample-add]');
    const quantity = selector.querySelector('[data-sample-quantity]');
    const status = selector.querySelector('[data-sample-status]');
    const compareButton = selector.querySelector('[data-sample-compare]');
    const comparePanel = selector.querySelector('[data-floor-compare-panel]');
    const compareItems = selector.querySelector('[data-compare-items]');
    const compareKey = 'ohanory-floor-comparison';
    let comparison = [];
    try { comparison = JSON.parse(localStorage.getItem(compareKey) || '[]'); } catch (error) { comparison = []; }
    const saveComparison = () => {
      localStorage.setItem(compareKey, JSON.stringify(comparison));
    };
    const renderComparison = () => {
      if (!compareItems) return;
      if (!comparison.length) {
        compareItems.innerHTML = '<p>No floors selected yet. Choose a color and add it to your shortlist.</p>';
        return;
      }
      compareItems.innerHTML = comparison.map((item) => `
        <article class="ohana-premium__compare-item">
          ${item.image ? `<img src="${item.image}" alt="">` : '<span></span>'}
          <div>
            <h4>${item.productName || item.tone}</h4>
            <dl>
              <div><dt>Collection</dt><dd>${item.collection || '—'}</dd></div>
              <div><dt>Color tone</dt><dd>${item.tone || '—'}</dd></div>
              <div><dt>Plank length</dt><dd>${item.length || '—'}</dd></div>
              <div><dt>Plank width</dt><dd>${item.width || '—'}</dd></div>
              <div><dt>Thickness</dt><dd>${item.thickness || '—'}</dd></div>
              <div><dt>Price / sq. ft.</dt><dd>${item.price || '—'}</dd></div>
              <div><dt>Sample availability</dt><dd>${item.sampleAvailability || '—'}</dd></div>
            </dl>
            <div class="ohana-premium__compare-links">
              <a href="${item.url}">View Floor</a>
              <a href="${item.sampleUrl || '/pages/order-samples'}">Request a Sample / Preview</a>
            </div>
          </div>
          <button type="button" data-compare-remove="${item.key}" aria-label="Remove ${item.tone} from comparison">×</button>
        </article>`).join('');
    };
    const openComparison = () => {
      renderComparison();
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({event:'compare_floors',floor_count:comparison.length});
      comparePanel.hidden = false;
      document.body.classList.add('ohana-compare-open');
      comparePanel.querySelector('[data-compare-close]')?.focus();
    };
    const closeComparison = () => {
      comparePanel.hidden = true;
      document.body.classList.remove('ohana-compare-open');
      compareButton?.focus();
    };
    const updateSelection = (input) => {
      if (!input) return;
      if (output) output.textContent = input.dataset.message;
      if (price) price.textContent = input.dataset.priceLabel + ' · ' + input.dataset.length;
      if (view) view.href = input.dataset.productUrl;
      if (add) add.disabled = !input.dataset.variantId;
      const featuredImage = selector.querySelector('[data-sample-feature-image]');
      if (featuredImage && input.dataset.featuredSrc) {
        featuredImage.removeAttribute('srcset');
        featuredImage.src = input.dataset.featuredSrc;
        featuredImage.alt = input.dataset.featuredAlt;
      }
      const featuredSeries = selector.querySelector('[data-feature-series]');
      const featuredTone = selector.querySelector('[data-feature-tone]');
      const featuredCode = selector.querySelector('[data-feature-code]');
      if (featuredSeries) featuredSeries.textContent = input.dataset.series;
      if (featuredTone) featuredTone.textContent = input.dataset.tone;
      if (featuredCode) featuredCode.textContent = input.dataset.code;
    };
    selector.addEventListener('change', (event) => {
      if (!event.target.matches('input[type="radio"]')) return;
      updateSelection(event.target);
    });
    compareButton?.addEventListener('click', () => {
      const selected = selector.querySelector('input[type="radio"]:checked');
      if (!selected) return;
      const key = selected.dataset.productUrl + '::' + selected.dataset.length;
      if (!comparison.some((item) => item.key === key)) {
        if (comparison.length >= 3) {
          if (status) status.textContent = 'You can compare up to three floors. Remove one before adding another.';
          openComparison();
          return;
        }
        comparison.push({
          key,
          productName: selected.dataset.productName,
          collection: selected.dataset.collection || selected.dataset.series,
          tone: selected.dataset.tone,
          reference: selected.value,
          length: selected.dataset.length,
          width: selected.dataset.width || '—',
          thickness: selected.dataset.thickness || '—',
          price: selected.dataset.priceLabel,
          sampleAvailability: selected.dataset.sampleAvailability || '—',
          sampleUrl: selected.dataset.sampleUrl || '/pages/order-samples',
          url: selected.dataset.productUrl,
          image: selected.dataset.featuredSrc || ''
        });
        saveComparison();
      }
      openComparison();
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({event:'select_compare',tone:selected.dataset.tone,reference:selected.value,plank_length:selected.dataset.length});
    });
    comparePanel?.addEventListener('click', (event) => {
      if (event.target.matches('[data-compare-close]')) closeComparison();
      const key = event.target.dataset.compareRemove;
      if (key) {
        comparison = comparison.filter((item) => item.key !== key);
        saveComparison();
        renderComparison();
      }
      if (event.target.matches('[data-compare-clear]')) {
        comparison = [];
        saveComparison();
        renderComparison();
      }
    });
    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && comparePanel && !comparePanel.hidden) closeComparison();
    });
    if (add) add.addEventListener('click', async () => {
      const selected = selector.querySelector('input[type="radio"]:checked');
      if (!selected || !selected.dataset.variantId) return;
      const amount = Math.max(1, Math.ceil(Number(quantity?.value) || 1));
      add.disabled = true;
      if (status) status.textContent = 'Adding selected flooring...';
      try {
        const response = await fetch('/cart/add.js', {
          method: 'POST',
          headers: {'Content-Type': 'application/json'},
          body: JSON.stringify({items: [{
            id: Number(selected.dataset.variantId),
            quantity: amount,
            properties: {
              'Flooring tone': selected.dataset.tone,
              'Product reference': selected.value,
              'Plank length': selected.dataset.length,
              'Purchase unit': '1 sq. ft.'
            }
          }]})
        });
        if (!response.ok) throw new Error('Unable to add this floor. Please try again.');
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({event:'add_flooring_swatch_to_cart',tone:selected.dataset.tone,reference:selected.value,plank_length:selected.dataset.length,quantity:amount});
        window.location.href = '/cart';
      } catch (error) {
        if (status) status.textContent = error.message;
        add.disabled = false;
      }
    });
    updateSelection(selector.querySelector('input[type="radio"]:checked'));
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ohanory-sample-box"] && !Shopify.designMode) return;
  try {
    
(()=>{document.querySelectorAll('[data-preview-request-page]:not([data-initialized])').forEach(root=>{root.dataset.initialized='true';const form=root.querySelector('.osb__form'),type=form?.querySelector('[data-request-type]'),floor=form?.querySelector('[data-floor-select]'),photo=form?.querySelector('[data-request-photo]'),consent=form?.querySelector('[data-photo-consent]'),utm=form?.querySelector('[data-utm-field]');const publish=(event,payload={})=>{if(window.OhanoryTrack){window.OhanoryTrack(event,payload);return}window.dataLayer=window.dataLayer||[];window.dataLayer.push({event,...payload})};publish('sample_page_view',{source:'sample_page'});if(root.querySelector('[data-preview-success]')){publish('sample_request_submit',{source:'sample_page'});return}const params=new URLSearchParams(location.search);const floorHandle=params.get('floor');if(floorHandle&&floor){const option=[...floor.options].find(item=>item.dataset.handle===floorHandle);if(option)floor.value=option.value}if(params.get('request')==='sample'&&type)type.value='Physical flooring sample';if(utm){const values={};params.forEach((value,key)=>{if(key.toLowerCase().startsWith('utm_'))values[key]=value});utm.value=Object.entries(values).map(([key,value])=>key+'='+value).join('&')}photo?.addEventListener('change',()=>{consent.required=Boolean(photo.files?.length)});let started=false;form?.addEventListener('focusin',()=>{if(started)return;started=true;publish('sample_request_start',{source:'sample_page'})});form?.addEventListener('submit',()=>publish('sample_request_submit',{source:'sample_page',request_type:type?.value||'unspecified',floor_handle:floorHandle||'manual_selection'}));root.querySelectorAll('[data-preview-start="sample"]').forEach(link=>link.addEventListener('click',()=>{if(type)type.value='Physical flooring sample'}));});})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pet-color-customizer"] && !Shopify.designMode) return;
  try {
    
    (() => {
      const roots = document.querySelectorAll('.pet-match:not([data-initialized])');
      const publish = (eventName, payload = {}) => {
        try {
          if (window.Shopify?.analytics?.publish) {
            window.Shopify.analytics.publish(eventName, payload);
          }
        } catch (error) {
          // Customization remains available when analytics is unavailable.
        }
      };

      roots.forEach((root) => {
        root.dataset.initialized = 'true';
        const input = root.querySelector('.pet-match__file');
        const image = root.querySelector('.pet-match__photo');
        const frame = root.querySelector('.pet-match__photo-frame');
        const filename = root.querySelector('.pet-match__file-name');
        const status = root.querySelector('.pet-match__status');
        const swatches = root.querySelector('.pet-match__swatches');
        const selectedInput = root.querySelector('.pet-match__selected-input');
        const hexOutput = root.querySelector('.pet-match__hex');
        const form = root.querySelector('.pet-match__form');
        const lengthInput = root.querySelector('[data-area-length]');
        const widthInput = root.querySelector('[data-area-width]');
        const wasteInput = root.querySelector('[data-area-waste]');
        const quantityInput = root.querySelector('.pet-match__quantity');
        const areaOutput = root.querySelector('[data-area-total]');
        const variantSelect = root.querySelector('[data-pet-variant]');
        const variantIdInput = root.querySelector('[data-pet-variant-id]');
        const priceOutput = root.querySelector('[data-pet-price]');
        variantSelect?.addEventListener('change', () => {
          const option = variantSelect.selectedOptions[0];
          if (variantIdInput) variantIdInput.value = variantSelect.value;
          if (priceOutput && option) priceOutput.textContent = option.dataset.priceLabel;
        });

        if (root.dataset.bespoke === 'true') {
          document
            .querySelectorAll('product-form-component[data-product-url="/products/petmatch-bespoke-custom-pet-color-flooring"]')
            .forEach((productForm) => {
              const standardBuyButtons = productForm.closest('.buy-buttons-block');
              if (standardBuyButtons) standardBuyButtons.hidden = true;
            });
        }

        const updateArea = () => {
          const length = Number.parseFloat(lengthInput?.value || '0');
          const width = Number.parseFloat(widthInput?.value || '0');
          const waste = Number.parseFloat(wasteInput?.value || '0');

          if (length > 0 && width > 0) {
            const total = Math.max(1, Math.ceil(length * width * (1 + waste / 100)));
            quantityInput.value = String(total);
            areaOutput.textContent = `${total} ${root.dataset.areaSuffix}`;
          } else {
            areaOutput.textContent = '—';
          }
        };

        [lengthInput, widthInput, wasteInput].forEach((areaField) => {
          areaField?.addEventListener('input', updateArea);
          areaField?.addEventListener('change', updateArea);
        });

        const rgbToHex = (red, green, blue) => {
          return `#${[red, green, blue].map((channel) => channel.toString(16).padStart(2, '0')).join('')}`.toUpperCase();
        };

        const distance = (first, second) => {
          return Math.sqrt(
            ((first[0] - second[0]) ** 2) +
            ((first[1] - second[1]) ** 2) +
            ((first[2] - second[2]) ** 2)
          );
        };

        const selectColor = (color, button) => {
          root.style.setProperty('--pet-tone', color);
          selectedInput.value = color;
          hexOutput.textContent = color;
          swatches.querySelectorAll('.pet-match__swatch').forEach((swatch) => {
            swatch.setAttribute('aria-checked', swatch === button ? 'true' : 'false');
            swatch.tabIndex = swatch === button ? 0 : -1;
          });
        };

        const renderSwatches = (colors) => {
          swatches.replaceChildren();
          colors.forEach((color, index) => {
            const button = document.createElement('button');
            button.type = 'button';
            button.className = 'pet-match__swatch';
            button.style.setProperty('--swatch', color);
            button.setAttribute('role', 'radio');
            button.setAttribute('aria-label', `${root.dataset.selectLabel} ${color}`);
            button.setAttribute('aria-checked', index === 0 ? 'true' : 'false');
            button.tabIndex = index === 0 ? 0 : -1;
            button.addEventListener('click', () => selectColor(color, button));
            button.addEventListener('keydown', (event) => {
              if (!['ArrowLeft', 'ArrowRight'].includes(event.key)) return;
              event.preventDefault();
              const buttons = [...swatches.querySelectorAll('.pet-match__swatch')];
              const direction = event.key === 'ArrowRight' ? 1 : -1;
              const next = buttons[(buttons.indexOf(button) + direction + buttons.length) % buttons.length];
              next.focus();
              next.click();
            });
            swatches.append(button);
          });

          if (colors[0]) {
            selectColor(colors[0], swatches.firstElementChild);
          }
        };

        const manualPalette = ['#F0E9DC', '#D9C5A8', '#C39450', '#8A6246', '#969B9B', '#302824', '#B89C7C'];
        renderSwatches(manualPalette);

        const extractColors = (sourceImage) => {
          const canvas = document.createElement('canvas');
          const context = canvas.getContext('2d', { willReadFrequently: true });
          canvas.width = 72;
          canvas.height = 72;
          context.drawImage(sourceImage, 0, 0, canvas.width, canvas.height);
          const pixels = context.getImageData(0, 0, canvas.width, canvas.height).data;
          const buckets = new Map();

          for (let index = 0; index < pixels.length; index += 16) {
            if (pixels[index + 3] < 200) continue;
            const red = Math.min(240, Math.round(pixels[index] / 24) * 24);
            const green = Math.min(240, Math.round(pixels[index + 1] / 24) * 24);
            const blue = Math.min(240, Math.round(pixels[index + 2] / 24) * 24);
            const brightness = (red + green + blue) / 3;
            if (brightness < 18 || brightness > 242) continue;
            const key = `${red},${green},${blue}`;
            buckets.set(key, (buckets.get(key) || 0) + 1);
          }

          const ranked = [...buckets.entries()]
            .sort((first, second) => second[1] - first[1])
            .map(([key]) => key.split(',').map(Number));
          const distinct = [];

          ranked.some((color) => {
            if (distinct.every((existing) => distance(existing, color) > 52)) {
              distinct.push(color);
            }
            return distinct.length === 4;
          });

          return distinct.map((color) => rgbToHex(color[0], color[1], color[2]));
        };

        input.addEventListener('change', () => {
          const file = input.files && input.files[0];
          if (!file) return;
          publish('find_their_floor_photo_upload', {
            source: 'custom_color',
            file_type: file.type || 'unknown'
          });

          if (file.size > Number(input.dataset.maxSize)) {
            input.value = '';
            frame.hidden = true;
            selectedInput.value = '';
            swatches.replaceChildren();
            status.textContent = root.dataset.fileTooLarge;
            return;
          }

          status.textContent = root.dataset.reading;
          filename.textContent = file.name;
          const reader = new FileReader();

          reader.addEventListener('load', () => {
            image.addEventListener('load', () => {
              try {
                const colors = extractColors(image);
                if (!colors.length) throw new Error('No colors extracted');
                renderSwatches(colors);
                frame.hidden = false;
                status.textContent = root.dataset.ready;
              } catch (error) {
                status.textContent = root.dataset.error;
                selectedInput.value = '';
                swatches.replaceChildren();
              }
            }, { once: true });
            image.src = reader.result;
          });

          reader.addEventListener('error', () => {
            status.textContent = root.dataset.error;
          });

          reader.readAsDataURL(file);
        });

        form.addEventListener('submit', (event) => {
          if (!selectedInput.value) {
            event.preventDefault();
            status.textContent = root.dataset.error;
            input.focus();
            return;
          }
          publish('find_their_floor_complete', {
            source: 'custom_color',
            photo_used: Boolean(input.files && input.files[0]),
            color: selectedInput.value
          });
        });
      });
    })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pet-color-harmony"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const roots = document.querySelectorAll('[data-find-their-floor-form]:not([data-initialized])');
    const publish = (eventName, payload = {}) => {
      try {
        if (window.Shopify?.analytics?.publish) window.Shopify.analytics.publish(eventName, payload);
      } catch (error) {
      }
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({ event: eventName, ...payload });
    };

    roots.forEach((form) => {
      form.dataset.initialized = 'true';
      const section = form.closest('.pet-harmony');
      const status = form.querySelector('[data-ftf-status]');
      const photoInput = form.querySelector('[data-ftf-photo]');
      const photoStatus = form.querySelector('[data-ftf-photo-status]');
      const photoPreview = form.querySelector('[data-ftf-photo-preview]');
      const photoImage = form.querySelector('[data-ftf-photo-image]');
      const recommendations = section?.querySelector('[data-ftf-recommendations]');
      const matchedGrid = recommendations?.querySelector('[data-ftf-matched-grid]');
      const meaningTitle = recommendations?.querySelector('[data-ftf-meaning-title]');
      const meaningWords = recommendations?.querySelector('[data-ftf-meaning-words]');
      const matchSummary = recommendations?.querySelector('[data-ftf-match-summary]');
      const catalogNode = section?.querySelector('[data-ftf-catalog]');
      const catalog = catalogNode ? JSON.parse(catalogNode.textContent) : {};
      let started = false;
      let currentMatch = null;

      publish('view_collection', { source: 'find_their_floor' });

      const meanings = {
        White: ['Pure Calm', 'Purity · Peace · Fresh Beginnings · Gentle Connection'],
        Cream: ['Soft Comfort', 'Comfort · Warmth · Love · Quiet Ease'],
        Golden: ['Golden Honey', 'Warmth · Loyalty · Joy · Companionship'],
        Brown: ['Earth & Home', 'Nature · Trust · Grounding · Belonging'],
        Grey: ['Quiet Silver', 'Calm · Balance · Wisdom · Modern Grace'],
        Black: ['Midnight Heritage', 'Protection · Strength · Trust · Depth'],
        Mixed: ['Shared Palette', 'Character · Connection · Playfulness · Individuality']
      };

      const reasons = {
        gold: [
          'A warm oak starting point that echoes honey and golden coat tones.',
          'A lighter golden grain that keeps the palette welcoming in natural light.',
          'A softly grounded wheat tone that adds warmth without feeling heavy.'
        ],
        ivory: [
          'A light neutral that reflects white and cream coats with quiet warmth.',
          'A softly washed oak that keeps pale palettes layered rather than flat.',
          'A natural light tone that brings gentle contrast to bright coats.'
        ],
        silver: [
          'A composed grey foundation that complements cool and silver coat tones.',
          'A cooler grain that supports a calm, balanced interior palette.',
          'A nuanced greige that bridges silver coats and warmer furnishings.'
        ],
        walnut: [
          'A deep grounded finish that connects black and brown coats to the room.',
          'A rich espresso tone that creates elegant contrast and visual depth.',
          'A warm walnut grain that balances strength with a lived-in character.'
        ],
        mixed: [
          'A versatile natural base that works with more than one coat tone.',
          'A warm middle tone that connects light and golden markings.',
          'A balanced greige that helps varied colors feel considered together.'
        ]
      };

      const markStarted = () => {
        if (started) return;
        started = true;
        publish('find_floor_start', { source: 'flooring_studio' });
      };

      const rgbToHex = (red, green, blue) => {
        return `#${[red, green, blue].map((channel) => channel.toString(16).padStart(2, '0')).join('')}`.toUpperCase();
      };

      const distance = (first, second) => Math.sqrt(
        ((first[0] - second[0]) ** 2) +
        ((first[1] - second[1]) ** 2) +
        ((first[2] - second[2]) ** 2)
      );

      const extractColors = (sourceImage) => {
        const canvas = document.createElement('canvas');
        const context = canvas.getContext('2d', { willReadFrequently: true });
        canvas.width = 72;
        canvas.height = 72;
        context.drawImage(sourceImage, 0, 0, canvas.width, canvas.height);
        const pixels = context.getImageData(0, 0, canvas.width, canvas.height).data;
        const buckets = new Map();

        for (let index = 0; index < pixels.length; index += 16) {
          if (pixels[index + 3] < 200) continue;
          const red = Math.min(240, Math.round(pixels[index] / 24) * 24);
          const green = Math.min(240, Math.round(pixels[index + 1] / 24) * 24);
          const blue = Math.min(240, Math.round(pixels[index + 2] / 24) * 24);
          const brightness = (red + green + blue) / 3;
          if (brightness < 18 || brightness > 242) continue;
          const key = `${red},${green},${blue}`;
          buckets.set(key, (buckets.get(key) || 0) + 1);
        }

        const ranked = [...buckets.entries()]
          .sort((first, second) => second[1] - first[1])
          .map(([key]) => key.split(',').map(Number));
        const distinct = [];
        ranked.some((color) => {
          if (distinct.every((existing) => distance(existing, color) > 52)) distinct.push(color);
          return distinct.length === 4;
        });
        return distinct.map((color) => rgbToHex(color[0], color[1], color[2]));
      };

      const classifyColor = (hex) => {
        const value = hex.replace('#', '');
        const red = parseInt(value.slice(0, 2), 16);
        const green = parseInt(value.slice(2, 4), 16);
        const blue = parseInt(value.slice(4, 6), 16);
        const max = Math.max(red, green, blue);
        const min = Math.min(red, green, blue);
        const saturation = max ? (max - min) / max : 0;
        const brightness = (red + green + blue) / 3;
        if (brightness < 62) return 'Black';
        if (saturation < .13 && brightness > 214) return 'White';
        if (saturation < .16 && brightness > 145) return 'Grey';
        if (brightness > 200 && red > blue) return 'Cream';
        if (red > blue * 1.16 && green > blue * 1.05 && brightness > 135) return 'Golden';
        if (red > blue * 1.15) return 'Brown';
        return brightness > 190 ? 'Cream' : 'Grey';
      };

      const selectDetectedColor = (color) => {
        const input = [...form.querySelectorAll('input[name^="ftf-color-"]')].find((option) => option.value === color);
        if (input) input.checked = true;
      };

      const selectFavorite = (product, card) => {
        currentMatch = { ...currentMatch, favorite: product };
        matchedGrid.querySelectorAll('.pet-harmony__matched-card').forEach((item) => item.classList.toggle('is-selected', item === card));
        matchedGrid.querySelectorAll('button').forEach((button) => button.textContent = button.closest('.pet-harmony__matched-card') === card ? 'SELECTED' : 'CHOOSE THIS FLOOR');
        recommendations.querySelectorAll('[data-ftf-preview-start],[data-ftf-sample-start],[data-ftf-pet-herringbone],[data-ftf-bespoke-quote]').forEach((button) => button.disabled = false);
        recommendations.querySelector('[data-ftf-selected-floor]').value = product.title;
        const floorImage = recommendations.querySelector('[data-ftf-preview-floor]'); if(floorImage) floorImage.src = product.image || '';
        const floorName = recommendations.querySelector('[data-ftf-preview-floor-name]'); if(floorName) floorName.textContent = product.title;
        const title = recommendations.querySelector('[data-ftf-preview-title]'); if(title) title.textContent = product.title;
        publish('floor_match_selected', { product_handle: product.handle, pet_color: currentMatch.color.toLowerCase() });
      };
      const openRequest = (requestType) => {
        if (!currentMatch?.favorite) return;
        const fields=recommendations.querySelector('[data-ftf-preview-fields]'), visualization=recommendations.querySelector('[data-ftf-visualization]');
        const typeField=recommendations.querySelector('[data-ftf-request-type]'), eyebrow=recommendations.querySelector('[data-ftf-form-eyebrow]');
        if(typeField) typeField.value=requestType; if(eyebrow) eyebrow.textContent=requestType.toUpperCase();
        if(visualization) visualization.hidden=false; if(fields) fields.hidden=false;
        const requestEvent=requestType==='Physical Flooring Sample'?'sample_request_start':requestType==='Pet-Color Herringbone'?'pet_color_herringbone_start':requestType==='Fully Bespoke Flooring Quote'?'custom_quote_start':'personalized_preview_start';
        publish(requestEvent,{request_type:requestType.toLowerCase().replaceAll(' ','_'),product_handle:currentMatch.favorite.handle});
        (visualization||fields)?.scrollIntoView({behavior:'smooth',block:'start'});
      };
      const renderMatches = (pet, color, family) => {
        const products=(catalog[family]||catalog.mixed||[]).filter((product)=>product&&product.title&&product.handle).slice(0,3);
        if(products.length!==3||!recommendations||!matchedGrid){if(status)status.textContent='We could not prepare three recommendations. Please choose another color or request help from our team.';return;}
        const story=meanings[color]||meanings.Mixed; currentMatch={pet,color,family,story,products,favorite:null};
        meaningTitle.textContent=story[0];meaningWords.textContent=story[1];
        matchSummary.textContent=`${pet}'s ${color.toLowerCase()} palette led to these three real flooring colors. Compare the finishes, then choose one favorite for your personalized preview.`;
        matchedGrid.replaceChildren();
        products.forEach((product,index)=>{
          const card=document.createElement('article');card.className='pet-harmony__matched-card';
          const image=document.createElement('img');image.src=product.image||'';image.alt=`${product.title} flooring`;image.loading='lazy';
          const copy=document.createElement('div'),title=document.createElement('h4'),price=document.createElement('p'),reason=document.createElement('p'),link=document.createElement('a'),choose=document.createElement('button');
          title.textContent=product.title;reason.textContent=reasons[family]?.[index]||'A real Ohanory floor selected to complement this coat-color family.';
          price.className='pet-harmony__match-price';price.textContent=`From ${product.price} / sq. ft.`;
          link.href=`${product.url}?matched=1&match=${encodeURIComponent(color.toLowerCase())}`;link.textContent='View This Floor';link.addEventListener('click',()=>publish('product_match_click',{product_handle:product.handle,color_family:family}));
          choose.type='button';choose.textContent='CHOOSE THIS FLOOR';choose.addEventListener('click',()=>selectFavorite(product,card));
          copy.append(title,price,reason,link,choose);card.append(image,copy);matchedGrid.append(card);
        });
        const petImage=recommendations.querySelector('[data-ftf-preview-pet]');if(petImage&&photoImage?.src)petImage.src=photoImage.src;
        recommendations.querySelector('[data-ftf-selected-color]').value=color;recommendations.querySelector('[data-ftf-selected-story]').value=`${story[0]} — ${story[1]}`;recommendations.querySelector('[data-ftf-selected-pet]').value=pet;
        recommendations.querySelector('[data-ftf-preview-color]').textContent=story[0];recommendations.querySelector('[data-ftf-preview-story]').textContent=story[1];
        recommendations.querySelectorAll('[data-ftf-preview-start],[data-ftf-sample-start],[data-ftf-pet-herringbone],[data-ftf-bespoke-quote]').forEach((button)=>button.disabled=true);
        recommendations.querySelector('[data-ftf-visualization]')?.setAttribute('hidden','');recommendations.querySelector('[data-ftf-preview-fields]')?.setAttribute('hidden','');
        recommendations.hidden=false;section?.classList.add('has-ftf-results');if(status)status.textContent=`${products.length} matching Ohanory floors are ready. Choose one favorite to continue.`;
        publish('floor_matches_viewed',{pet_type:pet.toLowerCase(),color_family:color.toLowerCase(),recommendation_count:3,products:products.map((product)=>product.handle)});
        publish('pet_color_herringbone_view',{color_family:color.toLowerCase(),source:'flooring_studio'});
        recommendations.scrollIntoView({behavior:'smooth',block:'start'});
      };

      form.addEventListener('change', markStarted);

      photoInput?.addEventListener('click', () => {
        publish('pet_photo_started', { source: 'flooring_studio' });
      }, { once: true });

      photoInput?.addEventListener('change', () => {
        const file = photoInput.files && photoInput.files[0];
        if (!file) return;
        markStarted();
        publish('pet_photo_upload', { source: 'flooring_studio', file_type: file.type || 'unknown' });
        if (file.size > Number(photoInput.dataset.maxSize)) {
          photoInput.value = '';
          photoStatus.textContent = 'This file is larger than 10 MB. Choose a smaller photo or select a color manually.';
          return;
        }

        photoStatus.textContent = 'Reading the color palette in this browser…';
        const reader = new FileReader();
        reader.addEventListener('load', () => {
          photoImage.addEventListener('load', () => {
            try {
              const colors = extractColors(photoImage);
              if (!colors.length) throw new Error('No colors extracted');
              const detected = classifyColor(colors[0]);
              selectDetectedColor(detected);
              photoPreview.hidden = false;
              photoStatus.textContent = `Closest detected color: ${detected}. Confirm it below or choose another color.`;
              publish('pet_color_generated',{color:detected.toLowerCase(),source:'browser_detection'});
            } catch (error) {
              photoStatus.textContent = 'We could not read this photo. Please choose the closest color manually.';
            }
          }, { once: true });
          photoImage.src = reader.result;
        });
        reader.addEventListener('error', () => {
          photoStatus.textContent = 'We could not read this photo. Please choose the closest color manually.';
        });
        reader.readAsDataURL(file);
      });

      form.addEventListener('submit', (event) => {
        event.preventDefault();
        markStarted();

        const pet = form.querySelector('input[name^="ftf-pet-"]:checked')?.value || 'Pet';
        const colorInput = form.querySelector('input[name^="ftf-color-"]:checked');
        const color = colorInput?.value || 'Mixed';
        const family = colorInput?.dataset.family || 'mixed';
        publish('pet_color_selected', { color: color.toLowerCase(), color_family: family, source: 'confirmation' });
        renderMatches(pet, color, family);
      });

      recommendations?.querySelector('[data-ftf-preview-start]')?.addEventListener('click',()=>openRequest('Personalized Floor Preview'));
      recommendations?.querySelector('[data-ftf-sample-start]')?.addEventListener('click',()=>openRequest('Physical Flooring Sample'));
      recommendations?.querySelector('[data-ftf-pet-herringbone]')?.addEventListener('click',()=>openRequest('Pet-Color Herringbone'));
      recommendations?.querySelector('[data-ftf-bespoke-quote]')?.addEventListener('click',()=>openRequest('Fully Bespoke Flooring Quote'));
      const requestForm=recommendations?.querySelector('.pet-harmony__preview-form');
      requestForm?.addEventListener('submit',()=>{
        const requestPhoto=requestForm.querySelector('[data-ftf-request-photo]');
        if(photoInput?.files?.[0]&&requestPhoto&&!requestPhoto.files?.length&&window.DataTransfer){const transfer=new DataTransfer();transfer.items.add(photoInput.files[0]);requestPhoto.files=transfer.files;}
        const params=new URLSearchParams(window.location.search);requestForm.querySelectorAll('[data-ftf-utm]').forEach((field)=>field.value=params.get(field.dataset.ftfUtm)||'');
        const requestType=requestForm.querySelector('[data-ftf-request-type]')?.value||'Personalized Floor Preview';
        const submitEvent=requestType==='Physical Flooring Sample'?'sample_request_submit':requestType==='Fully Bespoke Flooring Quote'?'custom_quote_submit':requestType==='Pet-Color Herringbone'?'custom_quote_submit':'personalized_preview_complete';
        publish(submitEvent,{request_type:requestType.toLowerCase().replaceAll(' ','_'),product:requestForm.querySelector('[data-ftf-selected-floor]')?.value||''});
      });
      if(recommendations?.querySelector('[data-ftf-preview-success]')){recommendations.hidden=false;recommendations.querySelector('[data-ftf-preview-success]')?.focus();}
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
